import React, { useCallback, useEffect, useState } from 'react';
import styles from './Tags.module.scss';
import { useTranslation } from 'react-i18next';
import VormatsAPI from '../../../../../common/apis/VormatsAPI';
import TagsControls from './TagsControls/TagsControls';
import { useUserContext } from '../../../../context/UserContext';

const Tags = ({ companyId }) => {
  const [tags, setTags] = useState([]);

  const { companyTags, updateTags } = useUserContext();
  const { t } = useTranslation();

  const handleSaveTag = async (name, color) => {
    await VormatsAPI.addCompanyTag(name, color, companyId);
    const updatedTags = await VormatsAPI.getCompanyTags(companyId);
    setTags(updatedTags);
    updateTags(updatedTags);
  };

  const handleRemoveRag = useCallback(
    async tagId => {
      const tagToRemove = tags.find(tag => tag.id === tagId);
      const confirm = window.confirm(t('company.settings.tags.remove_confirm', { name: tagToRemove.name }));
      if (confirm) {
        await VormatsAPI.removeCompanyTag(tagId, companyId);
        const updatedTags = await VormatsAPI.getCompanyTags(companyId);
        setTags(updatedTags);
        updateTags(updatedTags);
      }
    },
    [tags]
  );

  useEffect(() => {
    const loadTags = async () => {
      const tags = await VormatsAPI.getCompanyTags(companyId);
      setTags(tags);
    };

    if (companyId) {
      loadTags();
    } else {
      setTags(companyTags);
    }
  }, [companyId]);

  return (
    <div>
      <h2 className={styles.header}>{t('company.settings.tags.title')}</h2>
      <TagsControls tags={tags} editable={true} onSaveTag={handleSaveTag} onRemoveTag={handleRemoveRag} />
    </div>
  );
};

export default Tags;
